import Vue from 'vue'
import { uuid } from 'vue-uuid'

import api from 'Api'
import URL_DEMO from 'Demo/collectors.json'

const URL = '/collector'
const URL_LOGS = '/status'

const isDemoMode = process.env.VUE_APP_MODE === 'demo'

const state = {
  processingClusters: [],
  loadingProcessingClusters: true,
  _processingClusterLoadedItems: {
    processingClusters: {}
  }
}

const status = {
  processingClustersLoading: false
}

const getters = {
  processingClusters: state => {
    return state.processingClusters
  },
  loadingProcessingClusters: state => {
    return state.loadingProcessingClusters
  },
  _processingClusterLoadedItems: state => {
    return state._processingClusterLoadedItems
  }
}

function get (context, URL, handler) {
  return api().get(URL).then(response => handler(context, response))
}

function post (context, URL, data, handler) {
  return api().post(URL, data).then(response => handler(context, response))
}

function put (context, data, handler) {
  return api().put(URL, data).then(response => handler(context, response))
}

function apiDelete (context, URL, id, handler) {
  return api().delete(URL + '/' + id).then(response => handler(context, id, response))
}

function handleProcessingClusterLoad (context, response) {
  const processingClusters = response.data
  status.processingClustersLoading = false
  if (processingClusters.error) {
    context.commit('apiError', processingClusters.error)
  } else {
    context.commit('processingClustersLoaded', processingClusters)
    context.dispatch('getAllServers')
  }
  context.commit('setloadingProcessingClusters', false)
}

function handleProcessingClustersSave (context, response) {
  const processingCluster = response.data
  if (processingCluster.error) {
    context.commit('apiError', processingCluster.error)
  } else {
    context.commit('processingClustersSuccess', processingCluster)
  }
}

function handleProcessingClusterDelete (context, id, response) {
  const processingCluster = response.data
  if (processingCluster.error) {
    context.commit('apiError', processingCluster.error)
  } else {
    context.commit('processingClusterDeleted', id)
  }
}

// function addIfPresent (source, destination, propertyName) {
//   if (source[propertyName]) {
//     destination[propertyName] = source[propertyName]
//   }
// }

function addOrUpdateProcessingCluster (processingClusters, processingCluster) {
  processingClusters = processingClusters.map(item => item.entity_id !== processingCluster.entity_id ? item : { ...item, ...processingCluster })

  if (!processingClusters.find(item => item.entity_id === processingCluster.entity_id)) {
    processingClusters.push(processingCluster)
  }

  return processingClusters
}

function handlePollSave (context, response) {
  const poll = response.data
  if (poll.error) {
    context.commit('apiError', poll.error)
  } else {
    context.commit('pollSuccess', poll)
  }
}

const actions = {
  loadProcessingClusters (context, payload) {
    const organizationId = String(payload.entity_id)
    if (status.processingClustersLoading && state._processingClusterLoadedItems.processingClusters[organizationId]) {
      return
    }
    if (payload.entity_id) {
      status.processingClustersLoading = true
      if (!isDemoMode) {
        context.commit('setloadingProcessingClusters', true)
        get(context, URL + '/organization/' + (payload.partner === 'msp_client' ? payload.parent_id : organizationId) + '?collector_type=management', handleProcessingClusterLoad).then(() => {
          state._processingClusterLoadedItems.processingClusters[organizationId] = true
          // context.commit('setloadingProcessingClusters', false)
        }).catch(console.error)
      } else {
        handleProcessingClusterLoad(context, { data: URL_DEMO })
      }
    }
  },
  // getDemoprocessingClusters (context, payload) {
  //   const processingClusters = get(context)
  // },
  saveProcessingCluster (context, payload) {
    const processingClusterData = {
      version: payload.version,
      entity_id: payload.entity_id,
      name: payload.name,
      collector_version: payload.collector_version,
      organization_id: payload.organization_id,
      drives: [],
      collector_type: payload.collector_type,
      environment_support: payload.environment_support,
      allowedScanTime: payload.allowedScanTime,
      allowedUploadTime: payload.allowedUploadTime,
      custom_ip: payload.custom_ip,
      custom_port: payload.custom_port
      // 'status': payload['status'],
    }
    let req
    if (payload.entity_id) {
      req = put(context, processingClusterData, handleProcessingClustersSave)
    } else {
      processingClusterData.entity_id = uuid.v4()
      req = post(context, URL, processingClusterData, handleProcessingClustersSave)
    }
    // context.commit('updateprocessingClusterData', processingClusterData);
    return req
  },
  savePoll (context, payload) {
    const pollData = {
      version: payload.version,
      id: payload.id,
      collector_version: payload.collector_version,
      polling_interval: payload.polling_interval
    }
    if (!payload.api_key) {
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: 'No any active API Key'
      })
      return
    }
    const axios = api()
    axios.defaults.headers.authorization = 'Bearer ' + payload.api_key // need to change header
    return axios.post('/poll', pollData).then(response => handlePollSave(context, response))
  },
  deleteProcessingCluster (context, id) {
    state.processingClusters = state.processingClusters.filter(processingClusters => processingClusters.entity_id !== id)
    return apiDelete(context, URL, id, handleProcessingClusterDelete)
  }
}

const mutations = {
  processingClustersLoaded (state, processingClusters) {
    state.processingClusters = processingClusters
  },
  processingClustersSuccess (state, processingCluster) {
    state.processingClusters = addOrUpdateProcessingCluster(state.processingClusters, processingCluster)
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Processing Cluster Saved'
    })
  },
  processingClusterDeleted (state, id) {
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Processing Cluster deleted'
    })
  },
  updateProcessingClusterData (state, processingCluster) {
    state.processingClusters = addOrUpdateProcessingCluster(state.processingClusters, processingCluster)
  },
  setloadingProcessingClusters (state, loading) {
    state.loadingProcessingClusters = loading
  },
  pollSuccess (state, poll) {
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Interval Saved'
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'processingClustersStore'
}
